import React, { useState } from 'react';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="container mx-auto px-4 sm:px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 flex items-center justify-center">
              
                <div className="w-12 h-12 flex items-center justify-center">
                  <img 
                    src="/logo.png" 
                    alt="ADAPT Technology Solutions Logo" 
                    className="h-10 w-auto"
                  />
                </div>
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-logo-navy">ADAPT</h1>
                <p className="text-xs text-logo-darkblue -mt-1">TECHNOLOGY CONSULTING</p>
              </div>
            </div>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-logo-darkblue font-medium hover:text-logo-lightblue transition-colors"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-logo-navy hover:text-logo-lightblue transition-colors"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-logo-navy hover:text-logo-lightblue transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('approach')}
              className="text-logo-navy hover:text-logo-lightblue transition-colors"
            >
              Approach
            </button>
            <button 
              onClick={() => scrollToSection('industries')}
              className="text-logo-navy hover:text-logo-lightblue transition-colors"
            >
              Industries
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-logo-navy hover:text-logo-lightblue transition-colors"
            >
              Contact
            </button>
          </div>
          
          {/* Desktop CTA Button */}
          <button 
            onClick={() => scrollToSection('contact')}
            className="hidden md:block btn-primary px-6 py-2 rounded-lg font-medium"
          >
            Get Started
          </button>
          
          {/* Mobile Menu Button */}
          <button 
            id="mobile-menu-button"
            className="md:hidden text-logo-navy focus:outline-none"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
          </button>
        </div>
        
        {/* Mobile Navigation Menu */}
        <div className={`mobile-menu md:hidden ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="px-2 pt-2 pb-4 space-y-2 bg-white border-t border-gray-200 mt-4">
            <button 
              onClick={() => scrollToSection('home')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('approach')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              Approach
            </button>
            <button 
              onClick={() => scrollToSection('industries')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              Industries
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block text-logo-navy hover:text-logo-lightblue font-medium py-2 px-4 hover:bg-gray-50 rounded-lg w-full text-left"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block btn-primary text-center font-medium py-3 px-4 rounded-lg mt-4 w-full"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;